/**
 *
 * 方案汇报 - 模型显示隐藏配置 1.0
 *
 * 功能点:修改瓦片透明度、亮度,倾斜摄影透明度.
 * 场景:方案汇报
 *
 */
import Vue from "@/main";
import * as mapWorkDyeing from "@/components/tables/program/scenerModel/map.js";
import { color } from "echarts";
/**
 * 显示已勾选模型
 */
export function modelAddRemove(type, id, fn, ...list) {
  let map = Vue.$GLOBAL.map;
  if (list.length > 0) {
    let { mapType } = list[0];
    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
      console.log("加载副屏幕模型");
    }
  }
  let bimModel = findPnodeId(Vue.$GLOBAL.ptDataList, id)?.bimModel;
  if (bimModel == null || bimModel == undefined) return;
  let modelItem = map.getLayer(id, "modelId");
  switch (type) {
    case "add":
      if (modelItem == null || modelItem == undefined) {
        addModel(bimModel, id, fn, list[0]);
      }
      break;
    case "remove":
      removeModel(id, list[0]);
      break;
    default:
      break;
  }
}

function removeModel(id, ...list) {
  let map = Vue.$GLOBAL.map;
  if (list.length > 0 && list[0] != undefined) {
    let { mapType } = list[0];
    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }
  let modelItem = map.getLayer(id, "modelId");
  if (modelItem == null || modelItem == undefined) return;
  if (modelItem) map.removeLayer(modelItem);
}

function addModel(bimModel, id, fn, ...list) {
  let map = Vue.$GLOBAL.map;
  if (list.length > 0 && list[0] != undefined) {
    let { mapType } = list[0];
    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }
  // 判断模型是否在地图上
  console.log("已有模型", bimModel.id, map.getLayer(bimModel.id, "modelId"));
  let modelItem = map.getLayer(bimModel.id, "modelId");
  if (modelItem != null || modelItem != undefined) {
    return;
  }

  let modelId = bimModel.embsId;
  let modelType = bimModel ? bimModel.modelType : null;
  let modelTitle = bimModel ? bimModel.modelName : null;
  //let url = bimModel.modelUrl;
  let url =
    Vue.$GLOBAL.projectBaseUrl + Vue.$GLOBAL.modelBasePort + bimModel.modelUrl;
  let permission = bimModel.isDynamicReleased;
  let bimModelExcavationDetails = bimModel.bimModelExcavationDetails;
  let tiles3dLayer;
  if (bimModel.modelColor && bimModel.modelColor != "null") {
    tiles3dLayer = new mars3d.layer.TilesetLayer({
      modelId: modelId,
      modelColor: bimModel.modelColor,
      modelType: modelType,
      modelTitle: modelTitle,
      permission: permission,
      customize: {
        bimModelExcavationDetails: bimModelExcavationDetails,
      },
      url: encodeURI(url),
      maximumScreenSpaceError: 16,
      maximumMemoryUsage: 1024,
      flat: {
        precise: true,
        old: true,
      },
      style: {
        color: {
          conditions: [["true", bimModel.modelColor]],
        },
      },
      skipLevelOfDetail: true,
      loadSiblings: true,
      cullRequestsWhileMoving: true,
      cullRequestsWhileMovingMultiplier: 10,
      preferLeaves: true,
      progressiveResolutionHeightFraction: 0.5,
      dynamicScreenSpaceError: true,
      preloadWhenHidden: false,
      popup: `&nbsp;&nbsp; ${modelTitle} &nbsp;&nbsp;`,
      clip: { enabled: true, precise: true },
      // customShader: new Cesium.CustomShader({
      //   lightingModel: Cesium.LightingModel.UNLIT,
      // }),
    });
  } else {
    tiles3dLayer = new mars3d.layer.TilesetLayer({
      modelId: modelId,
      modelType: modelType,
      modelTitle: modelTitle,
      permission: permission,
      customize: {
        bimModelExcavationDetails: bimModelExcavationDetails,
      },
      url: encodeURI(url),
      maximumScreenSpaceError: 16,
      maximumMemoryUsage: 1024,
      flat: {
        precise: true,
        old: true,
      },
      skipLevelOfDetail: true,
      loadSiblings: true,
      cullRequestsWhileMoving: true,
      cullRequestsWhileMovingMultiplier: 10,
      preferLeaves: true,
      progressiveResolutionHeightFraction: 0.5,
      dynamicScreenSpaceError: true,
      preloadWhenHidden: false,
      popup: `&nbsp;&nbsp; ${modelTitle} &nbsp;&nbsp;`,
      clip: { enabled: true, precise: true },
      // customShader: new Cesium.CustomShader({
      //   lightingModel: Cesium.LightingModel.UNLIT,
      // }),
    });
  }

  tiles3dLayer.bindHighlight({
    //all:true,
    type: mars3d.EventType.click, // 默认为鼠标移入高亮，也可以指定click单击高亮
    color: "#FF0000",
  });
  tiles3dLayer.on(mars3d.EventType.load, (event) => {
    let item2 = viewShed.inquire(
      "modelArray",
      "modelId",
      event.layer.options.modelId
    );
    if (item2 != undefined) {
      item2.uid = event.layer.uuid;
    } else {
      viewShed.add("modelArray", {
        permission: event.layer.options.permission,
        modelId: event.layer.options.modelId,
        url: decodeURI(event.layer.options.url),
        uid: event.layer.uuid,
        center: event.layer._center,
        customize: event.layer.options.customize,
      });
    }
    // 回调，模型加载完毕
    if (fn != undefined && fn !== null) fn(Promise.resolve(true), event);
  });
  map.addLayer(tiles3dLayer);
}

function findPnodeId(data, id) {
  //设置结果
  let result;
  if (!data) {
    return; //如果data传空，直接返回
  }
  for (var i = 0; i < data.length; i++) {
    let item = data[i];
    if (item.id == id) {
      result = item;
      //找到id相等的则返回父id
      return result;
    } else if (item.children && item.children.length > 0) {
      //如果有子集，则把子集作为参数重新执行本方法
      result = findPnodeId(item.children, id);
      //关键，千万不要直接return本方法，不然即使没有返回值也会将返回return，导致最外层循环中断，直接返回undefined,要有返回值才return才对
      if (result) {
        return result;
      }
    }
  }
  //如果执行循环中都没有return，则在此return
  return result;
}
